module.exports = __webpack_public_path__ + "fonts/Inter-700-vietnamese68.5fc7f74.woff2";